import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    connect() {
        const socket = new SockJS('/webSocket/ws/ep');// 连接SockJS的endpoint名称为"bullet"
        // console.log('socket连接地址：'+'http://'+config.webSocketUrl+'/bullet');
        // 获取STOMP子协议的客户端对象
        console.log("开始建立Socket连接");
        let stompClient = Stomp.over(socket);
        console.log("建立stomp对象")
        // 定义客户端的认证信息,按需求配置
        // let headers = {
        //   Authorization:store.getters.token
        // };

        // 拦截输出的一大堆垃圾信息
        // stompClient.debug = function (str) {
        //   $("#debug").append(str + "\n");
        // };
        // 向服务器发起websocket连接
        stompClient.connect({},() => {
          stompClient.subscribe('/user/queue/order/chat', (response) => { // 订阅服务端提供的某个topic
            if (response.body) {
              const repObj = JSON.parse(response.body);
              if (repObj.data.webSocketType == 'ISEVehicle') { //监控管理，新版车辆监控
                if (repObj.status == 200) {
                  store.dispatch('carMonitorFun', repObj);
                }  else if (repObj.data.webSocketType == 'vehicleAlarm') { //首页，车辆告警数据推送
                if (repObj.status == 200) {
                  store.commit('vehicleAlarmMUTA', repObj.data);
                }
              }
            }
          };
          stompClient.subscribe('/user/'+store.getters.userRegionCode+'/queue/getResponse', (response) => { // 订阅服务端提供的某个topic
            if (response.body) {
              const repObj = JSON.parse(response.body);
               if (repObj.data.webSocketType == 'personAlarm') { //首页，人脸预警数据推送
                if (repObj.status == 200) {
                  store.commit('personAlarmMUTA', repObj.data);
                }
              }
              else if (repObj.data.webSocketType == 'vehicleAlarm') { //首页，车辆告警数据推送
                if (repObj.status == 200) {
                  store.commit('vehicleAlarmMUTA', repObj.data);
                }
              }
            }
          });
          stompClient.subscribe('/user/'+store.getters.token+'/queue/getResponse', (response) => { // 订阅服务端提供的某个topic
            if (response.body) {
              let repObj = JSON.parse(response.body);
              if (repObj.data.webSocketType =='task') { store.commit('monitorStatus', repObj);} //任务列表//当监控到websocket有数据返回的时候，修改monitorStatus使其发生变化即可
              else if (repObj.data.webSocketType == 'networkConfig') { store.commit('monitorStatusMUTA', repObj);}//联网配置
             
            }
          });
        }, (err) => {
          // 连接发生错误时的处理函数
          console.log('失败')
        });
      })
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js